import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'
import type { IArticle } from '@/utils/types'

export default function useSeo(article?: IArticle) {
  const globalStore = useGlobalStore()

  const title = `${article?.subject}｜hengstyle Life｜${import.meta.env.VITE_WEBSITE_TITLE}`
  // const description = globalStore.seoDescriptions.henceCategory.replace(':name', article?.subject ?? '')
  const description = article?.seo?.meta_description
  const url = article?.seo?.canonical || `${import.meta.env.VITE_DOMAIN}/hence/article/${article?.seo.meta_slug ?? article?.id}`

  const breadcrumbs = [
    { title: 'hengstyle Life', isActive: false, url: '/hence' },
    { title: article?.categories[0]?.subject ?? '', isActive: true, url: `/hence/${article?.categories[0]?.seo?.meta_slug || article?.categories[0]?.id}` }
  ]
  globalStore.setBreadcrumbs(breadcrumbs)

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description,
    ogImage: article?.seo?.og_image?.link,
    keywords: article?.seo?.meta_keywords?.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'hengstyle Life',
            item: `${import.meta.env.VITE_DOMAIN}/hence`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: article?.categories[0]?.subject,
            item: `${import.meta.env.VITE_DOMAIN}/hence/${article?.categories[0]?.seo?.meta_slug || article?.categories[0]?.id}`
          },
          {
            '@type': 'ListItem',
            position: 4,
            name: article?.subject,
            item: url
          }
        ]
      },
      {
        '@type': 'Article',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': url
        },
        headline: article?.subject,
        image: article?.seo?.og_image?.link,
        publisher: {
          '@type': 'Organization',
          name: '恆隆行',
          logo: {
            '@type': 'ImageObject',
            url: 'https://testwww.hengstyle.com/_ipx/f_webp/images/default.jpg'
          }
        },
        datePublished: article?.publish_date,
        author: {
          '@type': 'Person',
          name: article?.author?.name,
          url: `${import.meta.env.VITE_DOMAIN}/hence/author/${article?.author?.id}`
        }
      }
    ]
  })
}
